module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"t1":"Initial Public Offering","t2":"Subscription is open from","t3":"16-23 March, 2023","msg1":"Al Ansari Financial Services Initial Public Offering"},"ar":{"t1":"الــطــرح الــعــام الأولـي","t2":"الاكـتتـاب","t3":"23-16 مارس 2023","msg1":"الاكتتاب العام الأولي لشركة الأنصاري للخدمات المالية"}}')
  delete Component.options._Ctor
}
